/* eslint-disable default-param-last */
import {
  SHOW_LOGIN_LOADER,
  SET_LOGIN_ERROR,
  SET_LOGIN_SUCCESS,
} from "../../Constants/ActionConstants";

const INITIAL_STATE = {
  loginError: {},
  loginInfo: {},
  showLoginLoader: false,
  isLoggedIn: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_LOGIN_LOADER:
      state.showLoginLoader = action.payload;
      return {
        ...state,
      };
    case SET_LOGIN_ERROR:
      state.loginError = action.payload;
      state.showLoginLoader = false;
      return {
        ...state,
      };

    case SET_LOGIN_SUCCESS:
      state.loginInfo = action.payload;
      return {
        ...state,
      };

    default:
      return state;
  }
};
export default authReducer;
